<template>
  <div>
    <div v-if="youtube" class="youtube-holder">
      <div ref="ytplayer"></div>
    </div>
    <div v-if="isVimeo" class="youtube-holder vimeo">
      <iframe ref="playerframe" 
        :src="'https://player.vimeo.com/video/' + code + '?autoplay=0&loop=1&autopause=1'" 
        width="100%" height="auto" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </div>
    <div v-if="!isVimeo && !youtube && url" class="cameo-holder">
      <video controls class="cam-den" ref="lamvid">
        <source :src="srcUrl" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script>
import YTPlayer from 'yt-player'
import VideoParser from '@/utils/video-parser.js'
import vplayer from '@vimeo/player'

export default {
  props: {
    url: String
  },
  data () {
    return {
      player: null
    }
  },
  computed: {
    code: function() {
      if(this.url) {
        if(this.youtube) {
          return VideoParser.getYoutubeCode(this.url)
        }
        return VideoParser.getVimeoCode(this.url)
      }
      return ''
    },
    youtube: function () {
      if(this.url) {
        return VideoParser.isYouTube(this.url)
      }
      return false
    },
    isVimeo() {
      if(this.url) {
        return VideoParser.isVimeo(this.url)
      }
      return false
    },
    srcUrl() {
      if(this.url) {
        if(!this.url.endsWith('.mp4')){
          return this.url + '.mp4'
        }
      }
      return this.url
    }
    
  },
  mounted () {
    this.init()
  },
  beforeDestroy() {
    this.unload()
  },
  methods: {
    unload () {
      try {
        if(this.player) {
          this.player.destroy()
        }
      }
      catch(err){
        console.log('err destroying player', err)
      }
    },
    async init() {
      if(this.youtube) {
        this.player = this.player = new YTPlayer(this.$refs.ytplayer, {
          autoplay: false,
          modestBranding: true,
          related: false,
          width: '100%',
          height: 'auto'
        })
        await this.$k.waitfor(1000)
        this.player.load(this.code)
        this.player.on('playing', () => {
          this.$emit('play')
        })
      }
      else if(this.isVimeo){
        this.player = new vplayer(this.$refs.playerframe)
        this.player.on('play', () => {
          this.$emit('play')
        })
      }
      else if(this.$refs.lamvid){
        this.$refs.lamvid.load()
      }
      
    }
  },
  watch: {
    url () {
      this.unload()
      this.init()
    }
  }
  
}
</script>

<style scoped>
.youtube-holder{
  position:relative;
}

.youtube-holder iframe{
  box-sizing:border-box;
  width:100%;
}

.cameo-holder{
  position:relative;
  width:100%;
}

.cam-den{
  width:100%;
}
</style>
